const customHolidays = [
  "2025-09-07", // Planned power outage - clinic closed
  "2026-04-05", // Easter Sunday - waitlist closed
];

export default customHolidays;
